import address from './address.js';
import boss from './boss';
import companyType from './company-type.js';
import partner from './partner.js';
import statusType from './status-type.js';
import taxOffice from './tax-office.js';

export default {
  address,
  boss,
  companyType,
  partner,
  statusType,
  taxOffice,
};
